module.exports = __webpack_public_path__ + "static/media/list_with_one_node.4464908f.png";